<div class="card-body custom-body-container modal-title mt-4">
  <div class="mb-2">
    <div class="title"><i class="fas fa-file-signature"></i> {{"TITLE.SIGNATURE-VALIDATOR" | translate}}</div>
  </div>
  <app-alert-add-document [message]="message"></app-alert-add-document>
  <div class="form-row">
    <div class="col-md-5 mb-3">
      <label class="font-weight-bold">{{"LABEL.SELECT-PDF-FILE" | translate}}</label>
      <div class="padding-select-file">
        <div class="custom-file content-file">
          <input type="file" class="custom-file-input w-100 content-file" accept="application/pdf"
                 id="customFile" (change)="change($event)">
          <label class="custom-file-label"
                 for="customFile">
            {{fileSelected ? fileSelected.name : "MESSAGE.SELECT" | translate }}
          </label>
        </div>
      </div>
    </div>
    <div class="col-md-1 custom-mt-24">
      <button class="btn btn-success text-center custom-buttom" (click)="validateDocumentPdf()"
              [disabled]="!fileSelected">
        <i class="fa fa-check-circle" aria-hidden="true"></i> {{"BUTTON.VALIDATE-SIGNATURES" | translate}}
      </button>
    </div>
  </div>
  <div *ngIf="verifySigners"><span>{{"MESSAGE.VERIFICATION-ALL-SIGNATURES" | translate}}</span>
  </div>
  <br>
  <div style="height: 90%">
    <div class="alert alert-danger" role="alert" *ngIf="invalidSignatures()">
      <i class="fa fa-times"></i> {{"MESSAGE.DOCUMENT-HAVE-INVALID-SIGNATURES"| translate}}
    </div>
    <div *ngIf="isPresentSigners && !this.invalidSignatures()">
      <div class="alert {{this.isModifiedAfterSignature() ? 'alert-warning' : 'alert-success'}}" role="alert">
        <i class="fa fa-signature"></i> Integridad: {{getDescription()}}
      </div>
      <div class="alert alert-success" role="alert">
        <i class="fa fa-signature"></i> {{"TITLE.ALL-SIGNATURES-ARE-VALID" | translate}}
      </div>
      <div class="table-responsive">
        <table class="table table-sm">
          <thead class="thead-custom-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">{{ "TABLE.HEADER.OPERATION" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.BY" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.CERTIFYING-ENTITY" | translate }}</th>
            <th scope="col">TSA</th>
            <th scope="col">{{ "TABLE.HEADER.DATE-TIME" | translate }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let operatorInfo of operatorsInfo; let index=index">
            <th scope="row">{{index + 1}}</th>
            <td class="custom-th">
              <i class="fa fa-check-circle custom-icon-success"></i>
            </td>
            <td>{{operatorInfo.operationDescription | translate}}</td>
            <td class="mw-157">{{operatorInfo.operatorName}}</td>
            <td class="mw-157">{{operatorInfo.issuerCertName}}</td>
            <td>{{operatorInfo.tsa}}</td>
            <td class="mw-60">{{operatorInfo.certainDateTime}}</td>
            <td>
              <span class="badge badge-info"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Ver más"
                    (click)="openModalSeeCertificateDetail(index)">
              {{ "BUTTON.VIEW-MORE" | translate }}
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="viewIframeContent && isPresentSigners" style="height: 650px">
      <ng2-pdfjs-viewer #embeddedPdf
                        [pdfSrc]="pdfSrc"
                        pagemode="none"
                        scroll="V"
                        id="pdfViewer"
                        aria-label="Embedded PDF"
                        viewerId="documentVisor">
      </ng2-pdfjs-viewer>
    </div>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
